import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormControl, FormGroupDirective, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {toggleEditMode} from '../../../shared/utils';
import {ProduktArt} from '../../../shared/enum';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'app-datenschutz-policy',
  templateUrl: './datenschutz-policy.component.html',
  styleUrls: ['./datenschutz-policy.component.scss']
})
export class DatenschutzPolicyComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  datenschutzPolicy: UntypedFormControl;

  @Input()
  showDatenschutzPolicy = true;

  @Input()
  produktArt: ProduktArt;

  productLinkInfo = '#';

  constructor(public translateService: TranslateService) { }

  static createDatenschutzPolicy() {
    return new UntypedFormControl('', Validators.requiredTrue);
  }

  ngOnInit(): void {
    this.toggleEditMode();
    this.getProduktInfoLink();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showDatenschutzPolicy && changes.showDatenschutzPolicy.currentValue !== changes.showDatenschutzPolicy.previousValue) {
      this.toggleEditMode();
    }
    if (changes.produktArt && changes.produktArt.currentValue !== changes.produktArt.previousValue) {
      this.getProduktInfoLink();
    }
  }

  toggleEditMode(): void {
    toggleEditMode(this.datenschutzPolicy, this.showDatenschutzPolicy);
  }

  getProduktInfoLink(): void {

    let link: Observable<any>;

    switch (this.produktArt){
      case ProduktArt.Kfz: {
        link = this.translateService.get('LINKPRODUCTINFOKFZ');
        break;
      }
      case ProduktArt.Motorrad:
      {
        link = this.translateService.get('LINKPRODUCTINFOMRAD');
        break;
      }
      case ProduktArt.Rechtschutz:
      {
        link = this.translateService.get('LINKPRODUCTINFORS');
        break;
      }
      case ProduktArt.Haushalt:{
        link = this.translateService.get('LINKPRODUCTINFOHAUSHALT');
        break;
      }
      case ProduktArt.Eigenheim:{
        link = this.translateService.get('LINKPRODUCTINFOEIGENHEIM');
        break;
      }
      default: {
        link = of('#');
      }
    }

    const self = this;
    link.subscribe( x => {
      self.productLinkInfo = x.toString();
    });
  }
}
